import React from 'react'
import styled from '@emotion/styled'
import { FlexRowDiv, FlexDiv } from '../generic/Basics'
import { grayLight20, fontWeightBold, fontSize3XSmall, fontSizeSmall, fontWeightRegular, grayLight10, grayLight40, greenLight } from '../../constants/principles'
import { breakpoints } from '../../constants'
import { formatPrice } from '../../utils/kbbUtils'

export default ({ dealerName, offerAmount, markupAmount, isDesktop }) => {
  if (!offerAmount || !markupAmount || offerAmount <= 1 || markupAmount <= 1) {
    return <></>
  }
  let formattedAmount = formatPrice(offerAmount)
  let formattedMarkup = formatPrice(markupAmount)
  let formattedTotal = formatPrice(offerAmount + markupAmount)
  return (
    <>
      <DealerIncentiveBox data-testid = {`oc-dealer-incentive-box`}>
        <DIBoxHeader>
          <DIBoxHeaderText>You Received A Dealer Boost!</DIBoxHeaderText>
          {dealerName && <DIBoxHeaderSubText data-testid = {`oc-dealer-incentive-box-dealer-name`}>from {dealerName}</DIBoxHeaderSubText>}
        </DIBoxHeader>
        <DISeparator />
        <DIBoxLineItem>
          <DIBoxLineItemText data-testid = {`oc-dealer-boost-kbbico-inbox`} fontWeight={fontWeightBold}>Kelley Blue Book&reg;{!isDesktop ? <br /> : ' '}Instant Cash Offer</DIBoxLineItemText>
          <BadgeText>1</BadgeText>
          <DIBoxLineItemEllipsis style={!isDesktop ? { height: '29px' } : {}}></DIBoxLineItemEllipsis>
          <DIBoxLineItemOffer data-testid = {`oc-dealer-boost-kbbico-amt`} style={!isDesktop ? { height: '29px' } : {}}>{formattedAmount}</DIBoxLineItemOffer>
        </DIBoxLineItem>
        <DIBoxLineItem>
          <DIBoxLineItemText data-testid = {`oc-dealer-boost-inbox`} green>Dealer Boost</DIBoxLineItemText>
          <BadgeText>2</BadgeText>
          <DIBoxLineItemEllipsis green></DIBoxLineItemEllipsis>
          <DIBoxLineItemOffer data-testid = {`oc-dealer-boost-amt`} green>+ {formattedMarkup}</DIBoxLineItemOffer>
        </DIBoxLineItem>
      </DealerIncentiveBox>
      <DealerIncentiveDisclaimer data-testid = {`oc-dealer-incentive-box-inbox-disclaimer`}>
        Dealer Boost amounts are determined and provided solely by, and can only be redeemed through, that Participating Dealer. Kelley Blue Book and its affiliates are not responsible for Offer adjustments, including Dealer Boosts.
      </DealerIncentiveDisclaimer>
    </>
  )
}

const DealerIncentiveBox = styled(FlexDiv)`
  border: solid 3px ${greenLight};
  border-radius: 10px;
  width: 100%;
  padding: 15px;
  font-size: 14px;
  font-weight: normal;
  @media (min-width: ${breakpoints.mid}px) {
    max-width: 460px;
  }
`
const DIBoxHeader = styled(FlexDiv)`
  width: 100%;
  text-align: left;
  @media (min-width: ${breakpoints.lg}px) {
    margin-bottom: 5px;
  }
`

const DIBoxHeaderText = styled.div`
  width: 100%;
  font-size: ${fontSizeSmall};
  font-weight: ${fontWeightBold};
  @media (min-width: ${breakpoints.lg}px) {
  }
`

const DIBoxHeaderSubText = styled.div`
  width: 100%;
  font-size: ${fontSize3XSmall};
  @media (min-width: ${breakpoints.lg}px) {
  }
`
const DISeparator = styled.hr`
  border: solid 1px ${grayLight40};
  width: 100%;
  margin-bottom: 10px;
`

const DIBoxLineItem = styled(FlexRowDiv)`
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
  @media (min-width: ${breakpoints.lg}px) {
  }
`

const DIBoxLineItemText = styled(FlexDiv)`
  margin-right: 10px;
  font-weight: ${p => (p.fontWeight ? p.fontWeight : fontWeightRegular)};
  color: ${p => p.green && greenLight};
`

const DIBoxLineItemEllipsis = styled(FlexDiv)`
  flex-grow: 1;
  height: 13px;
  border-bottom: dotted 1px ${p => (p.green ? greenLight : grayLight20)};
`

const DIBoxLineItemOffer = styled(FlexDiv)`
  font-weight: bold;
  margin-left: 10px;
  color: ${p => p.green && greenLight};
`

const DIBoxFooter = styled(DIBoxLineItem)`
  font-size: ${fontSizeSmall};
  font-weight: ${fontWeightBold};
  @media (min-width: ${breakpoints.lg}px) {
  }
`

const DealerIncentiveDisclaimer = styled.small`
  width: 100%;
  margin-top: 10px;
  font-size: 12px;
  font-weight: normal;
  @media (min-width: ${breakpoints.mid}px) {
    max-width: 460px;
  }
`
const BadgeText = styled.div`
  font-size: 10px;
  position: relative;
  top: -6px;
  left: -9px;
  color: #171818;
`
